import { render, staticRenderFns } from "./UpdoxBadPaymentRequestToken.vue?vue&type=template&id=3a2105b9"
import script from "./UpdoxBadPaymentRequestToken.vue?vue&type=script&lang=js"
export * from "./UpdoxBadPaymentRequestToken.vue?vue&type=script&lang=js"
import style0 from "./UpdoxBadPaymentRequestToken.vue?vue&type=style&index=0&id=3a2105b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_babel-core@7.0.0-bridge.0_@babel+core@7.28._1eb1b9dda9fe6d233009820956254809/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports